import { render, staticRenderFns } from "./keywordPanel.vue?vue&type=template&id=3a565384&scoped=true&"
import script from "./keywordPanel.vue?vue&type=script&lang=js&"
export * from "./keywordPanel.vue?vue&type=script&lang=js&"
import style0 from "./keywordPanel.vue?vue&type=style&index=0&id=3a565384&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a565384",
  null
  
)

export default component.exports